export default __webpack_public_path__ + "static/media/shape.dd56261c.svg";